/**
 * Modelo del usuario de SBSuite.
 *
 * @export
 * @class User
 */
export class User{


    /**
     * Nombre completo del usuario.
     *
     * @private
     * @type {string}
     * @memberof User
     */
    private _name: string  = '';

    /**
     * Id del usuario.
     *
     * @private
     * @type {number}
     * @memberof User
     */
    private _id: number = 0;


    /**
     * Nivel de acceso del usuario.
     *
     * A partir de 9 se puede considerar admin.
     * 
     * @private
     * @type {number}
     * @memberof User
     */
    private _level: number = null;

    /**
     * Parámetros del usuario.
     *
     * @private
     * @type {*}
     * @memberof User
     */
    private _params: any  = {};

    /**
     * Token de autenticación.
     *
     * @private
     * @type {string}
     * @memberof User
     */
    private _token: string = '';


    /**
     * Nombre getter.
     *
     * @type {string}
     * @memberof User
     */
    get name(): string{
        return this._name;
    }

    /**
     * Nombre setter.
     *
     * @memberof User
     */
    set name(name: string){
        this._name = name;
    }

    /**
     * Id getter;
     *
     * @type {number}
     * @memberof User
     */
    get id(): number{
        return this._id;
    }

    /**
     * Id setter.
     *
     * @memberof User
     */
    set id(id: number){
        this._id = id;
    }

    /**
     * Nivel getter;
     *
     * @type {number}
     * @memberof User
     */
    get level(): number{
        return this._level;
    }

    /**
     * Nivel setter.
     *
     * @memberof User
     */
    set level(level: number){
        this._level = level;
    }

    /**
     * Parámetros getter.
     *
     * @type {*}
     * @memberof User
     */
    get params(): any{
        return this._params;
    }

    /**
     *Parámetros setter.
     *
     * @memberof User
     */
    set params(params: any){
        if(typeof params == 'string'){
            let p = params.split(';');
            p.forEach(element => {
                this._params[element] = true;
            });
        }
        else  this._params = params;
    }

    /**
     * Token getter.
     *
     * @type {string}
     * @memberof User
     */
    get token(): string{
        return this._token;
    }

    /**
     * Token setter.
     *
     * @memberof User
     */
    set token(token: string){
        this._token = token;
    }

    /**
     * Crea una instancia de User.
     * 
     * @param {*} params Parametros: un JOSN o una classe User.
     * @memberof User
     */
    constructor(params?: any){
        if(!params) return;
        if(params instanceof User){ //Copy instance
            this.name = params.name;
            this.id = params.id;
            this.level  = params.level;
            this.params = JSON.parse(JSON.stringify(params.params));
            this.token = params.token;
        }
        else if(typeof params == 'object'){
            //Serialized
            if(typeof params._id != 'undefined') this.id = params._id;
            if(typeof params._name != 'undefined') this.name = params._name;
            if(typeof params._level != 'undefined') this.level = params._level;
            if(typeof params._params != 'undefined') this.params = params._params;
            if(typeof params._token != 'undefined') this.token = params._token;

            //Http response
            if(typeof params.fullname != 'undefined') this.name = params.fullname;
            if(typeof params.id_usuario != 'undefined') this.id = params.id_usuario;
            if(typeof params.level != 'undefined') this.level = params.level;
            if(typeof params.params != 'undefined') this.params = params.params;
            if(typeof params.token != 'undefined') this.token = params.token;
        }
    }

    isAdmin(){
        if(this.level>8) return true;
        return false;
    }

    showTabs(): string{
        if(this.id == 0) return '';
        else if(this.isAdmin()){
            if(this.params.fichajestiemporeal) return 'all';
            else return 'manually';
        }
        else{
            if(!(this.params.fichajestiemporeal)) return 'manually';
            else return 'auto';
        }
    }

    getRole(){
        if(this.level>9) return 'superadmin'
        if(this.level>8) return 'admin';
        if(this.level>0) return 'user';
        return ''
    }

    isEmpty(){
        if(this.id == 0) return true;
    }
}


// WEBPACK FOOTER //
// ./src/modules/sbsuite/models/user.model.ts